import type { FC } from 'react';

interface Props {
  className?: string;
}

const OpenConceptIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 9h6v6H9V9z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 9h6M15 9h6M9 3v6M9 15v6"
      />
    </svg>
  );
};

export default OpenConceptIcon;
